import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getPatientEnrollmentInsight, getPatientPieInsight } from "../../api/insights";
import { failed } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";
import ReactApexChart from "react-apexcharts";
import FilterBar from "./FilterBar";

const PatientsGraph = (activeTab) => {
  console.log(activeTab.activeTab);
  const [dropdownOpenTimeline, setDropdownOpenTimeline] = useState(false);
  const toggleTimeline = () => setDropdownOpenTimeline((prevState) => !prevState);

  const [dropdownOpenMeasures, setDropdownOpenMeasures] = useState(false);
  const toggleMeasures = () => setDropdownOpenMeasures((prevState) => !prevState);

  const [dropdownOpenGroupBy, setDropdownOpenGroupBy] = useState(false);
  const toggleGroupBy = () => setDropdownOpenGroupBy((prevState) => !prevState);

  const [fromDate, setFromDate] = useState(dayjs().subtract(30, "day").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [timeline, setTimeline] = useState("Daily");
  const [measures, setMeasures] = useState("Total");
  const [groupBy, setGroupBy] = useState("Select");
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pieChartData, setPieChartData] = useState([]);
  let token = useSelector(state => state.userReducer.token);
  const dispatch = useDispatch();

  useEffect(() => {
    if(activeTab.activeTab === "1"){
    if (fromDate && toDate && dayjs(toDate).isAfter(dayjs(fromDate))) {
      fetchPatientData();
    }
  }
  }, [fromDate, toDate, timeline, measures, groupBy, activeTab]);

  const fetchPatientData = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getPatientEnrollmentInsight({ values : {orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId"), fromDate, toDate, timeline, groupBy, measures }, dispatch, token});
      if (res?.status === "SUCCESS") {
        setChartData(res?.data);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if(activeTab.activeTab === "1"){
      fetchPatientPieData();
    }
  }, [activeTab]);

  const fetchPatientPieData = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getPatientPieInsight({ values : {orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId"), fromDate, toDate, timeline, groupBy, measures }, dispatch, token});
      if (res?.status === "SUCCESS") {
        setPieChartData(res?.data);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

console.log(chartData,"chartData");
const chartOptions = {
  chart: { type: "bar", stacked: true, height: 350 },
  xaxis: { categories: chartData.map((item) => item._id) },
  legend: { position: "bottom", offsetY: 20 },
  fill: { opacity: 1 }
};

const pieDepartmentApprovalOptions = {
  options: {
    chart: { type: "pie"},
    labels: pieChartData?.departmentApproval?.map(item => item.label) || [],
    theme: {
      palette: "palette2",
      monochrome: { shadeIntensity: 0.6 }
    },
    legend: { position: "left", offsetY: 40 },
    title: {
      text: "Patients Department Approval", // ✅ Updated Dynamic Title
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#333"
      }
    }
  },
  series: pieChartData?.departmentApproval?.map(item => item.value) || []
};

const pieActiveArchieveOptions = {
  options: {
    chart: { type: "pie" },
    labels: pieChartData?.activeVsArchived?.map(item => item.label) || [],
    theme: {
      palette: "palette2",
      monochrome: { shadeIntensity: 0.6 }
    },
    legend: { position: "left", offsetY: 40 },
    title: {
      text: "Patients Active vs Archieved", // ✅ Updated Dynamic Title
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#333"
      }
    }
  },
  series: pieChartData?.activeVsArchived?.map(item => item.value) || []
};
  return (
    <>
      <div className="d-flex justify-content-center align-items-center mb-4 pt-4">
        <h4>Patients</h4>
      </div>
      {isLoading ? <Loader /> : null}
      <div className="d-flex gap-3 flex-wrap">
        <div className="graph_block">
          <div className="d-flex justify-content-end align-items-center gap-4">
          <FilterBar
              fromDate={fromDate}
              setFromDate={setFromDate}
              toDate={toDate}
              setToDate={setToDate}
              timeline={timeline}
              setTimeline={setTimeline}
              dropdownOpenTimeline={dropdownOpenTimeline}
              toggleTimeline={toggleTimeline}
              measures={measures}
              setMeasures={setMeasures}
              dropdownOpenMeasures={dropdownOpenMeasures}
              toggleMeasures={toggleMeasures}
              groupBy={groupBy}
              setGroupBy={setGroupBy}
              dropdownOpenGroupBy={dropdownOpenGroupBy}
              toggleGroupBy={toggleGroupBy}
            />
          </div>

          {/* ✅ Bar Chart */}
          <div id="chart">
            <ReactApexChart options={chartOptions} series={[
              { name: "Pending", data: chartData.map((item) => item.pending) },
              { name: "Approved", data: chartData.map((item) => item.approved) },
              { name: "Rejected", data: chartData.map((item) => item.rejected) },
              { name: "Not Started", data: chartData.map((item) => item.notstarted) },
              { name: "Started", data: chartData.map((item) => item.started) },
              { name: "In Progress", data: chartData.map((item) => item.inprogress) }
            ]} type="bar" height={350} />
          </div>
        </div>
      </div>

      {/* ✅ Pie Chart Section */}
      <div className="piechart_block row">
        <div className="col-xl-4  mb-20">
        <div className="piechart_one h-100">
          <Chart options={pieDepartmentApprovalOptions.options} series={pieDepartmentApprovalOptions.series} type="pie" width="380" />
        </div>
        </div>
        <div className="col-xl-4  mb-20">
        <div className="piechart_one h-100">
          <Chart options={pieActiveArchieveOptions.options} series={pieActiveArchieveOptions.series} type="pie" width="380" />
        </div>
        </div>
        <div className="col-xl-4  mb-20">
        <div className="piechart_one h-100">
          <Chart options={pieDepartmentApprovalOptions.options} series={pieDepartmentApprovalOptions.series} type="pie" width="380" />
        </div>
        </div>
      </div>
    </>
  );
};

export default PatientsGraph;
